<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title="$t('model.walk/challenge')"
    resource="walk/challenges"
    :tabs="tabs"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../../admin_grapes/walk/challenges.js';
import WalkChallengeParticipationRecords from './challenge_participation_records.vue';
import WalkChallengeWinners from './walk_challenge_winners.vue';
import challengeAnalysics from './challenge_analytics.vue';

@Component({
  components: {
    WalkChallengeParticipationRecords,
    WalkChallengeWinners,
    challengeAnalysics
  }
})
export default class WalkChallenges extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  get tabs() {
    const detailtitle = `${this.$t('model.walk/challenge')}-${this.$t('bean.actionDetail')}`
    return [
      {
        label: detailtitle,
        columns: this.columns(this.$createElement, { type: 'show' }),
      },
      {
        label: this.$t('model.walk/challengeParticipationRecord'),
        can: 'walk_challenge_participation_records.read',
        showAction: false,
        renderCell: (h, value) => {
          if (value) {
            return <WalkChallengeParticipationRecords type="index" walkChallengeId={value.id} title={detailtitle} />
          }
        }
      },
      {
        label: this.$t('menu.analytics'),
        can: 'walk_challenges.read',
        showAction: false,
        renderCell: (h, value) => {
          if (value) {
            return <challengeAnalysics type="index" walkChallengeId={value.id} title={detailtitle} />
          }
        }
      },
      {
        label: this.$t('menu.winners'),
        can: 'walk_challenge_participation_records.read',
        showAction: false,
        renderCell: (h, value) => {
          if (value) {
            return <WalkChallengeWinners type="index" walkChallengeId={value.id} title={detailtitle} />
          }
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'title_cont',
      'walk_club_id_eq',
      'walk_prize_id_eq',
      {
        prop: 'start_date_gteq',
        label: `${this.$t('walk/challenge.startDate')} ${this.$t('after')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'start_date_lteq',
        label: `${this.$t('walk/challenge.startDate')} ${this.$t('before')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'end_date_gteq',
        label: `${this.$t('walk/challenge.endDate')} ${this.$t('after')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'end_date_lteq',
        label: `${this.$t('walk/challenge.endDate')} ${this.$t('before')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'walk_club',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'walk/clubs.show', params: { id: value.id } }}>{value.name}</bean-link>
          }
        }
      },
      {
        key: 'title',
        minWidth: 160,
      },
      type === 'show' && 'sub_title',
      'target',
      'start_date',
      'end_date',
      'amount_cents',
      type === 'show' && {
        key: 'walk_prize',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'walk/prizes.show', params: { id: value.id } }}>{value.title}</bean-link>
          }
        }
      },
      type === 'show' && 'prize_desc',
      'winners_count',
      type === 'show' && {
        key: 'is_started',
        renderCell: 'bool',
      },
      {
        key: 'is_ended',
        renderCell: 'bool',
      },
      type === 'show' && { key: 'introduction' },
      type === 'show' && 'cover',
      type === 'show' && 'detail_image',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'walk_club_id',
      'title',
      'sub_title',
      'target',
      'start_date',
      'end_date',
      'amount_cents',
      'walk_prize_id',
      'prize_desc',
      'winners_count',
      'introduction',
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 300x300`,
        }
      },
      {
        key: 'detail_image',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x396`,
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'walk/challenges.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'walk/challenges.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/walk/challenges',
    name: 'walk/challenges.index',
    component: WalkChallenges,
    props: {
      type: 'index',
    }
  },
  {
    path: '/walk/challenges/new',
    name: 'walk/challenges.new',
    component: WalkChallenges,
    props: {
      type: 'new',
    }
  },
  {
    path: '/walk/challenges/:id',
    name: 'walk/challenges.show',
    component: WalkChallenges,
    props: {
      type: 'show',
    }
  },
  {
    path: '/walk/challenges/:id/edit',
    name: 'walk/challenges.edit',
    component: WalkChallenges,
    props: {
      type: 'edit'
    }
  }
]
</script>
